import { EyeOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

const StyledLink = styled(Link)`
  margin-bottom: 0.5rem;
  .anticon {
    margin-right: 0.5rem;
    vertical-align: middle;
    line-height: 1rem;
  }
`;

interface IDamageDetailsLinkProps {
  id: string;
  type: string;
  className?: string;
}

export const DamageDetailsLink = ({ id, type, className = '' }: IDamageDetailsLinkProps) => {
  const { t } = useTranslation();
  return (
    <StyledLink
      to={`/damages/${id}`}
      type={type}
      className={`${className} ${type === 'button' ? 'ant-btn' : null}`}
    >
      <EyeOutlined />
      {t('damage.viewDetails', 'View Details')}
    </StyledLink>
  );
};
